<template>
  <AppModal
    class="upload-event-file-modal"
    :disabled="isSubmitting"
    @close="$emit('close')"
  >
    <template #header>
      Upload {{ imageType }}
    </template>

    <FileInput
      :disabled="isSubmitting"
      :validation-error="errors || validationError"
      @file-uploaded="handleChange"
    />

    <div class="flex items-center justify-center">
      <img
        v-if="data.file || image"
        :src="dataUrl || image"
        class="object-cover object-center mb-10 max-w-[200px]"
      >
    </div>

    <div class="flex gap-3">
      <AppButton
        class="btn-outline btn-secondary w-full max-w-sm"
        @click="$emit('close')"
      >
        Cancel
      </AppButton>

      <AppButton
        class="btn-solid btn-secondary w-full max-w-sm"
        :disabled="data.file === null || errors !== null"
        :processing="isSubmitting || processing"
        @click="$emit('upload', data)"
      >
        {{ isSubmitting || processing ? 'Uploading' : 'Upload' }}
      </AppButton>
    </div>
  </AppModal>
</template>

<script setup>
import { onUnmounted, reactive, ref } from 'vue';

import { AppButton, AppModal } from '@/components/app';

import { FileInput } from '@/components/forms/inputs';

defineEmits(['upload', 'close']);

defineProps({
  imageType: {
    type: String,
    default: '',
  },
  processing: {
    type: Boolean,
    default: false,
  },
  validationError: {
    type: String,
    default: null,
  },
  image: {
    type: String,
    default: null,
  },
});

const errors = ref(null);
const isSubmitting = ref(false);

const data = reactive({ file: null });
const dataUrl = ref(false);

const handleChange = (e) => {
  errors.value = null;
  const fileInput = e.target;
  const file = fileInput.files.length ? fileInput.files[0] : null;

  if (!file) {
    return;
  }

  // const maxSizeInMB = 5;
  // const maxSizeInBytes = maxSizeInMB * 1024 * 1024;
  //
  // if (file.size > maxSizeInBytes) {
  //   fileInput.value = '';
  //   errors.value = 'File size exceeds the maximum limit of 5MB.';
  //   data.file = null;
  //   return;
  // }

  data.file = file;

  // creating an image to display
  if (dataUrl.value) {
    URL.revokeObjectURL(dataUrl.value);
  }

  dataUrl.value = URL.createObjectURL(file);
};

// clean up created image
onUnmounted(() => {
  if (dataUrl.value) {
    URL.revokeObjectURL(dataUrl.value);
  }
});
</script>
